import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = () =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      outerContainer: {
        background: 'transparent',
        height: '833px',
        minWidth: '100%',
        padding: '0px 24px 24px 24px',
        [theme.breakpoints.down('lg')]: {
          height: '1660px'
        }
      },
      innerContainer: {
        background: 'white',
        borderRadius: '8px',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        height: '809px',
        minWidth: '100%',
        overflow: 'hidden',
        padding: '32px 64px',
        display: 'grid',
        gridTemplateRows: 'min-content min-content auto',
        [theme.breakpoints.down('lg')]: {
          height: '1640px'
        }
      },
      headerContainer: {
        padding: '0 0 16px',
        width: '100%'
      },
      tilesContainer: {
        display: 'grid',
        gridAutoRows: '1fr',
        gap: '24px',
        padding: '24px 0'
      },
      tileCheckbox: {
        width: '100%',
        height: '100%',
        justifyContent: 'space-between'
      }
    })
  );
